import { styled } from "@woba/ds-web";

export const SubtitleWrapper = styled("div", {
  flex: 1,
  display: "flex",
  gap: "$space-04",

  "@md": {
    flexDirection: "column",
    gap: "$space-03",
    width: "100%",
  },
});

export const ContainerProducts = styled("div", {
  width: "100%",
});
export const ContainerValueTotal = styled("div", {
  display: "flex",
  alignItems: "baseline",
  justifyContent: "space-between",

  "@sm": {
    flexDirection: "column",

    "& > div": {
      width: "100%",

      "&:first-child": {
        borderBottomStyle: "solid",
        borderBottomWidth: "1px",
        borderColor: "$neutral-200",
        marginBottom: "$space-03",
      },
    },
  },
});

export const TotalValue = styled("span", {
  fontSize: 48,
  fontWeight: 500,
});
export const SimbolValue = styled("div", {
  fontSize: 24,
  fontWeight: 400,

  svg: {
    marginRight: "$space-04",
    maxWidth: "2.187rem",
  },
});

export const ProductsItems = styled("div", {
  display: "flex",
  justifyContent: "space-between",
  "@sm": {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gap: "$space-04",
  },
});

export const PercentContainer = styled("div", {
  margin: "$space-05 0",
});

export const ActionButtonsFinancialContainers = styled("div", {});

export const ContainerTotalValue = styled("div", {
  display: "flex",
  alignItems: "baseline",
});
